import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90385a22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-width w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "bg-primary text-color-white" }
const _hoisted_5 = {
  id: "partial-resultghg-table-header1",
  colspan: "5",
  scope: "colgroup"
}
const _hoisted_6 = { style: {"font-weight":"600"} }
const _hoisted_7 = {
  id: "partial-resultghg-subheader-1",
  headers: "partial-resultghg-table-header1",
  style: {"width":"30%"},
  class: "py-405 align-text-left bg-alternative"
}
const _hoisted_8 = {
  id: "partial-resultghg-subheader-2",
  headers: "partial-resultghg-table-header1",
  style: {"width":"18%"},
  class: "py-405 align-text-right bg-alternative"
}
const _hoisted_9 = {
  id: "partial-resultghg-subheader-3",
  headers: "partial-resultghg-table-header1",
  style: {"width":"14%"},
  class: "py-405 align-text-right bg-alternative"
}
const _hoisted_10 = {
  id: "partial-resultghg-subheader-4",
  headers: "partial-resultghg-table-header1",
  style: {"width":"18%"},
  class: "py-405 align-text-right bg-alternative"
}
const _hoisted_11 = {
  id: "partial-resultghg-subheader-5",
  headers: "partial-resultghg-table-header1",
  style: {"width":"20%"},
  class: "py-405 align-text-right bg-alternative"
}
const _hoisted_12 = { class: "bg-primary text-color-white" }
const _hoisted_13 = {
  headers: "partial-resultghg-subheader-1",
  class: "align-text-left"
}
const _hoisted_14 = {
  key: 0,
  class: "small-text"
}
const _hoisted_15 = {
  headers: "partial-resultghg-subheader-2",
  class: "align-text-right"
}
const _hoisted_16 = {
  headers: "partial-resultghg-subheader-3",
  class: "align-text-right"
}
const _hoisted_17 = {
  headers: "partial-resultghg-subheader-4",
  class: "align-text-right"
}
const _hoisted_18 = {
  headers: "partial-resultghg-subheader-5",
  class: "align-text-right"
}
const _hoisted_19 = { role: "row" }
const _hoisted_20 = {
  headers: "partial-resultghg-subheader-1",
  class: "align-text-left"
}
const _hoisted_21 = {
  headers: "partial-resultghg-subheader-2",
  class: "align-text-right"
}
const _hoisted_22 = {
  headers: "partial-resultghg-subheader-3",
  class: "align-text-right"
}
const _hoisted_23 = {
  headers: "partial-resultghg-subheader-4",
  class: "align-text-right"
}
const _hoisted_24 = {
  headers: "partial-resultghg-subheader-5",
  class: "align-text-right"
}
const _hoisted_25 = { style: {"font-weight":"600"} }
const _hoisted_26 = { class: "align-text-left" }
const _hoisted_27 = { class: "align-text-right" }
const _hoisted_28 = { class: "align-text-right" }
const _hoisted_29 = { class: "align-text-right" }
const _hoisted_30 = { class: "align-text-right" }
const _hoisted_31 = { role: "row" }
const _hoisted_32 = { class: "pl-5 align-text-left" }
const _hoisted_33 = { class: "align-text-right" }
const _hoisted_34 = { class: "align-text-right" }
const _hoisted_35 = { class: "align-text-right" }
const _hoisted_36 = { class: "align-text-right" }
const _hoisted_37 = {
  style: {"font-weight":"600"},
  class: "bg-primary text-color-white"
}
const _hoisted_38 = { class: "align-text-left" }
const _hoisted_39 = { class: "small-text" }
const _hoisted_40 = { class: "align-text-right" }
const _hoisted_41 = { class: "align-text-right" }
const _hoisted_42 = { class: "align-text-right" }
const _hoisted_43 = { class: "align-text-right" }
const _hoisted_44 = { style: {"font-weight":"600"} }
const _hoisted_45 = { class: "align-text-left" }
const _hoisted_46 = { class: "small-text" }
const _hoisted_47 = { class: "align-text-right" }
const _hoisted_48 = { class: "align-text-right" }
const _hoisted_49 = { class: "align-text-right" }
const _hoisted_50 = { class: "align-text-right" }
const _hoisted_51 = { class: "full-width w-100" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = ["aria-label"]
const _hoisted_54 = { class: "bg-primary text-color-white" }
const _hoisted_55 = {
  id: "partial-resultghg-table-header2",
  colspan: "5",
  scope: "colgroup"
}
const _hoisted_56 = { class: "small-text" }
const _hoisted_57 = { style: {"font-weight":"600"} }
const _hoisted_58 = {
  id: "partial-resultghg-table2-subheader-1",
  style: {"width":"30%"},
  class: "py-405 align-text-left bg-alternative"
}
const _hoisted_59 = {
  id: "partial-resultghg-table2-subheader-2",
  style: {"width":"20%"},
  class: "py-405 align-text-right bg-alternative"
}
const _hoisted_60 = { class: "bg-primary text-color-white" }
const _hoisted_61 = {
  headers: "partial-resultghg-table2-subheader-1",
  class: "align-text-left"
}
const _hoisted_62 = {
  key: 0,
  class: "small-text"
}
const _hoisted_63 = {
  headers: "partial-resultghg-table2-subheader-2",
  class: "align-text-right"
}
const _hoisted_64 = { role: "row" }
const _hoisted_65 = {
  headers: "partial-resultghg-table2-subheader-1",
  class: "align-text-left"
}
const _hoisted_66 = {
  headers: "partial-resultghg-table2-subheader-2",
  class: "align-text-right"
}
const _hoisted_67 = { style: {"font-weight":"600"} }
const _hoisted_68 = {
  headers: "partial-resultghg-table2-subheader-1",
  class: "align-text-left"
}
const _hoisted_69 = {
  headers: "partial-resultghg-table2-subheader-2",
  class: "align-text-right"
}
const _hoisted_70 = { role: "row" }
const _hoisted_71 = {
  headers: "partial-resultghg-table2-subheader-1",
  class: "pl-5 align-text-left"
}
const _hoisted_72 = {
  headers: "partial-resultghg-table2-subheader-2",
  class: "align-text-right"
}
const _hoisted_73 = {
  style: {"font-weight":"600"},
  class: "bg-primary text-color-white"
}
const _hoisted_74 = {
  headers: "partial-resultghg-table2-subheader-1",
  class: "align-text-left"
}
const _hoisted_75 = { class: "small-text" }
const _hoisted_76 = {
  headers: "partial-resultghg-table2-subheader-2",
  class: "align-text-right"
}
const _hoisted_77 = { style: {"font-weight":"600"} }
const _hoisted_78 = {
  headers: "partial-resultghg-table2-subheader-1",
  class: "align-text-left"
}
const _hoisted_79 = { class: "small-text" }
const _hoisted_80 = {
  headers: "partial-resultghg-table2-subheader-2",
  class: "align-text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_ResultRowGHG = _resolveComponent("ResultRowGHG")!
  const _component_ResultRowGHG2Col = _resolveComponent("ResultRowGHG2Col")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, [
      _createVNode(_component_SimpleText, {
        "text-key": "calculation.subresult-ghg.tab.title",
        "aria-live": "polite"
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_directive_dompurify_html, this.getContentfulString('calculation.text.partial-result.description')]
    ]),
    _hoisted_2,
    (_ctx.results?.groupingResults)
      ? (_openBlock(), _createElementBlock("table", {
          key: 0,
          class: "table results-table w-percent-100",
          "aria-label": _ctx.getContentfulString('calculation.subresult-ghg.tab.title')
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_4, [
              _withDirectives(_createElementVNode("th", _hoisted_5, null, 512), [
                [_directive_dompurify_html, this.getContentfulString('calculation.partial-result-ghg.text.table.include-scopes.description')]
              ])
            ])
          ]),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_6, [
              _withDirectives(_createElementVNode("th", _hoisted_7, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.table1.maincategory')]
              ]),
              _withDirectives(_createElementVNode("th", _hoisted_8, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.partial-result.text.table1.scope1')]
              ]),
              _withDirectives(_createElementVNode("th", _hoisted_9, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.partial-result.text.table1.scope2')]
              ]),
              _withDirectives(_createElementVNode("th", _hoisted_10, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.partial-result.text.table1.scope3')]
              ]),
              _withDirectives(_createElementVNode("th", _hoisted_11, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.partial-result.text.table1.scope1-3')]
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.groupingResults, (result) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: result.groupingName
              }, [
                _createElementVNode("tr", _hoisted_12, [
                  _createElementVNode("td", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.publicCategoryTheme(result.groupingName)) + " ", 1),
                    (_ctx.shouldDisplayElectricityMethodForGrouping(result))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.prettify(result.calculatedResult?.scope1Result || 0, 2)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.prettify(result.calculatedResult?.scope2Result || 0, 2)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.prettify(result.calculatedResult?.scope3Result || 0, 2)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.prettify(result.calculatedResult?.scopesResult || 0, 2)), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.mergedSubgroupingsCalculated, (subResult) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: subResult.mergedSubgroupingName
                  }, [
                    _createElementVNode("tr", _hoisted_19, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.publicCategoryGroup(subResult.mergedSubgroupingName, result.groupingName)), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scope1Result || 0, 2)), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scope2Result || 0, 2)), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scope3Result || 0, 2)), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scopesResult || 0, 2)), 1)
                    ]),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_EL)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET_MED_EGNE_EMISSIONSFAKTORER,
                            subResult: subResult,
                            results: _ctx.results,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subResult", "results", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_VARME_OG_PROCESENERGI)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_FJERNVARME,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FJERNVARME)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_BRÆNDSLER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_BRÆNDSLER)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARME_OG_PROCESENERGI_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARME_OG_PROCESENERGI_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PROCESUDLEDNING)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_PROCESUDLEDNING,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_PROCESUDLEDNING)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_PROCESUDLEDNING_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_PROCESUDLEDNING_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_EGNE_OG_LEASEDE_TRANSPORTFORM)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_EGNE_OG_LEASEDE_KØRETØJER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_EGNE_OG_LEASEDE_KØRETØJER)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_FLY_OG_SKIBE,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FLY_OG_SKIBE)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_EGNE_OG_LEASEDE_TRANSPORTMIDLER_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_EGNE_OG_LEASEDE_TRANSPORTMIDLER_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_MEDARBEJDERTRANSPORT)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_PENDLING,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_PENDLING)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_FYSISKE_ENHEDER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_FYSISKE_ENHEDER)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_MONETÆRE_ENHEDER_BELØB_I_DKK,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_MONETÆRE_ENHEDER_BELØB_I_DKK)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_MEDARBEJDERTRANSPORT_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_MEDARBEJDERTRANSPORT_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_VARETRANSPORT_TIL_VIRKSOMHED)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARETRANSPORT_TIL_VIRKSOMHED_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_TIL_VIRKSOMHED_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_VARETRANSPORT_FRA_VIRKSOMHED_TIL_KUNDEN)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER_II,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER_II)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK_II,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK_II)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_VARETRANSPORT_FRA_VIRKSOMHED_TIL_KUNDE_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_FRA_VIRKSOMHED_TIL_KUNDE_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_AFFALD)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_AFFALD,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_AFFALD)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_AFFALD_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_AFFALD_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_END_OF_LIGE_BEHANDLING)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_END_OF_LIFE_BEHANDLING,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_END_OF_LIFE_BEHANDLING)
                          }, null, 8, ["result", "id", "subCategoryName"]),
                          _createVNode(_component_ResultRowGHG, {
                            result: result,
                            id: _ctx.constants.GROUP_END_OF_LIFE_BEHANDLING_MED_EGNE_EMISSIONSFAKTORER,
                            subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_END_OF_LIFE_BEHANDLING_MED_EGNE_EMISSIONSFAKTORER)
                          }, null, 8, ["result", "id", "subCategoryName"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (result.purchaseGroupingCalculatedResults)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(result.purchaseGroupingCalculatedResults, (subResult) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subResult.mergedSubgroupingName
                      }, [
                        _createElementVNode("tr", _hoisted_25, [
                          _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.publicCategoryGroup(subResult.mergedSubgroupingName, result.groupingName)), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scope1Result || 0, 2)), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scope2Result || 0, 2)), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scope3Result || 0, 2)), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.scopesResult || 0, 2)), 1)
                        ]),
                        (subResult.mergedSubgroupingsCalculated)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(subResult.mergedSubgroupingsCalculated, (purchaseResult) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: purchaseResult.mergedSubgroupingName
                              }, [
                                _createElementVNode("tr", _hoisted_31, [
                                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.publicCategoryPurchaseGroup(subResult.mergedSubgroupingName, purchaseResult.mergedSubgroupingName)), 1),
                                  _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.prettify(purchaseResult.calculatedResult?.scope1Result || 0, 2)), 1),
                                  _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.prettify(purchaseResult.calculatedResult?.scope2Result || 0, 2)), 1),
                                  _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.prettify(purchaseResult.calculatedResult?.scope3Result || 0, 2)), 1),
                                  _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.prettify(purchaseResult.calculatedResult?.scopesResult || 0, 2)), 1)
                                ]),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PRIMARE_INDKOEB_RAAVARER_PRODUKTION && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_MATERIALER)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PRIMARE_INDKOEB_RAAVARER_PRODUKTION && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_PRODUKTER_OG_SERVICES)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PRIMARE_INDKOEB_RAAVARER_PRODUKTION && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_ANDET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_SEKUNDARE_INDKOEB_HJAELPEMATERIALER_OG_SERVICEYDELSER && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_MATERIALER)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_SEKUNDARE_INDKOEB_HJAELPEMATERIALER_OG_SERVICEYDELSER && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_PRODUKTER_OG_SERVICES)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_SEKUNDARE_INDKOEB_HJAELPEMATERIALER_OG_SERVICEYDELSER && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_ANDET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("tr", _hoisted_37, [
              _createElementVNode("td", _hoisted_38, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.total" }),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_39, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ]),
              _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.scope1Result || 0, 2)), 1),
              _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.scope2Result || 0, 2)), 1),
              _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.scope3Result || 0, 2)), 1),
              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.totalResult || 0, 2)), 1)
            ]),
            _createElementVNode("tr", _hoisted_44, [
              _createElementVNode("td", _hoisted_45, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.total" }),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_46, "(" + _toDisplayString(this.electricityCalculationMethodText(!_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ]),
              _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.scope1ResultOtherDeclaration || 0, 2)), 1),
              _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.scope2ResultOtherDeclaration || 0, 2)), 1),
              _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.scope3ResultOtherDeclaration || 0, 2)), 1),
              _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.totalResultOtherDeclaration || 0, 2)), 1)
            ])
          ])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("h2", null, [
      _createVNode(_component_SimpleText, {
        "text-key": "calculation.mainresult-ghg.text.table.outside-scope",
        "aria-live": "polite"
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_51, null, 512), [
      [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult-ghg.text.table.outside-scope.description')]
    ]),
    _hoisted_52,
    (_ctx.results?.groupingResults)
      ? (_openBlock(), _createElementBlock("table", {
          key: 1,
          class: "table results-table w-percent-100",
          "aria-label": this.getContentfulString('calculation.mainresult-ghg.text.table.outside-scope')
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_54, [
              _createElementVNode("th", _hoisted_55, [
                _createVNode(_component_SimpleText, { "text-key": "calculation.partial-result-ghg.text.table.outside-scope.description" }),
                _createElementVNode("span", _hoisted_56, " (" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ])
            ])
          ]),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_57, [
              _withDirectives(_createElementVNode("th", _hoisted_58, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.data.text.main-category')]
              ]),
              _withDirectives(_createElementVNode("th", _hoisted_59, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.data.text.partial-result.outside-scope')]
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.groupingResults, (result) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: result.groupingName
              }, [
                _createElementVNode("tr", _hoisted_60, [
                  _createElementVNode("td", _hoisted_61, [
                    _createTextVNode(_toDisplayString(_ctx.publicCategoryTheme(result.groupingName)) + " ", 1),
                    (_ctx.shouldDisplayElectricityMethodForGrouping(result))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.prettify(result.calculatedResult?.outsideScopeResult || 0, 2)), 1)
                ]),
                (result.mergedSubgroupingsCalculated)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(result.mergedSubgroupingsCalculated, (subResult) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subResult.mergedSubgroupingName
                      }, [
                        _createElementVNode("tr", _hoisted_64, [
                          _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.publicCategoryGroup(subResult.mergedSubgroupingName, result.groupingName)), 1),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.outsideScopeResult || 0, 2)), 1)
                        ]),
                        (subResult.mergedSubgroupingName ===_ctx.constants.GROUP_NAME_EL)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FORBRUG_AF_ELEKTRICITET_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName ===_ctx.constants.GROUP_NAME_VARME_OG_PROCESENERGI)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_FJERNVARME,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FJERNVARME)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_BRÆNDSLER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_BRÆNDSLER)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARME_OG_PROCESENERGI_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARME_OG_PROCESENERGI_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PROCESUDLEDNING)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_PROCESUDLEDNING,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_PROCESUDLEDNING)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_PROCESUDLEDNING_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_PROCESUDLEDNING_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_EGNE_OG_LEASEDE_TRANSPORTFORM)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_EGNE_OG_LEASEDE_KØRETØJER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_EGNE_OG_LEASEDE_KØRETØJER)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_FLY_OG_SKIBE,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_FLY_OG_SKIBE)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_EGNE_OG_LEASEDE_TRANSPORTMIDLER_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_EGNE_OG_LEASEDE_TRANSPORTMIDLER_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_MEDARBEJDERTRANSPORT)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_PENDLING,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_PENDLING)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_FYSISKE_ENHEDER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_FYSISKE_ENHEDER)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_MONETÆRE_ENHEDER_BELØB_I_DKK,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_REJSER_I_FORBINDELSE_MED_ARBEJDE_MONETÆRE_ENHEDER_BELØB_I_DKK)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_MEDARBEJDERTRANSPORT_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_MEDARBEJDERTRANSPORT_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_VARETRANSPORT_TIL_VIRKSOMHED)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARETRANSPORT_TIL_VIRKSOMHED_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_TIL_VIRKSOMHED_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_VARETRANSPORT_FRA_VIRKSOMHED_TIL_KUNDEN)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER_II,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_FYSISKE_ENHEDER_II)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK_II,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_I_MONETÆRE_ENHEDER_BELØB_I_DKK_II)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_VARETRANSPORT_FRA_VIRKSOMHED_TIL_KUNDE_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_VARETRANSPORT_FRA_VIRKSOMHED_TIL_KUNDE_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_AFFALD)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_AFFALD,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_AFFALD)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_AFFALD_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_AFFALD_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_AFFALD_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_AFFALD_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_BRUG_AF_SOLGTE_OG_UDLEJEDE_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_END_OF_LIGE_BEHANDLING)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_END_OF_LIFE_BEHANDLING,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_END_OF_LIFE_BEHANDLING)
                              }, null, 8, ["result", "id", "subCategoryName"]),
                              _createVNode(_component_ResultRowGHG2Col, {
                                result: result,
                                id: _ctx.constants.GROUP_END_OF_LIFE_BEHANDLING_MED_EGNE_EMISSIONSFAKTORER,
                                subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_END_OF_LIFE_BEHANDLING_MED_EGNE_EMISSIONSFAKTORER)
                              }, null, 8, ["result", "id", "subCategoryName"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true),
                (result.purchaseGroupingCalculatedResults)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(result.purchaseGroupingCalculatedResults, (subResult) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subResult.mergedSubgroupingName
                      }, [
                        _createElementVNode("tr", _hoisted_67, [
                          _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.publicCategoryGroup(subResult.mergedSubgroupingName, result.groupingName)), 1),
                          _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.prettify(subResult.calculatedResult?.outsideScopeResult || 0, 2)), 1)
                        ]),
                        (subResult.mergedSubgroupingsCalculated)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(subResult.mergedSubgroupingsCalculated, (purchaseResult) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: purchaseResult.mergedSubgroupingName
                              }, [
                                _createElementVNode("tr", _hoisted_70, [
                                  _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.publicCategoryPurchaseGroup(subResult.mergedSubgroupingName, purchaseResult.mergedSubgroupingName)), 1),
                                  _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.prettify(purchaseResult.calculatedResult?.outsideScopeResult || 0, 2)), 1)
                                ]),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PRIMARE_INDKOEB_RAAVARER_PRODUKTION && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_MATERIALER)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PRIMARE_INDKOEB_RAAVARER_PRODUKTION && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_PRODUKTER_OG_SERVICES)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_PRIMARE_INDKOEB_RAAVARER_PRODUKTION && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_ANDET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_PRIMÆRE_INDKØB_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_SEKUNDARE_INDKOEB_HJAELPEMATERIALER_OG_SERVICEYDELSER && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_MATERIALER)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_MATERIALER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_SEKUNDARE_INDKOEB_HJAELPEMATERIALER_OG_SERVICEYDELSER && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_INDKOEB_PRODUKTER_OG_SERVICES)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_FYSISKE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_INDKØB_AF_PRODUKTER_MED_EGNE_EMISSIONSFAKTORER_I_MONETÆRE_ENHEDER_II)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (subResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_SEKUNDARE_INDKOEB_HJAELPEMATERIALER_OG_SERVICEYDELSER && purchaseResult.mergedSubgroupingName === _ctx.constants.GROUP_NAME_ANDET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_FYSISKE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_FYSISKE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"]),
                                      _createVNode(_component_ResultRowGHG2Col, {
                                        result: result,
                                        id: _ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_MONETÆRE_ENHEDER,
                                        subCategoryName: _ctx.publicSubCategoryGroup(_ctx.constants.GROUP_ANDET_UDLEDNING_VED_SEKUNDÆRE_INDKØB_I_MONETÆRE_ENHEDER)
                                      }, null, 8, ["result", "id", "subCategoryName"])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("tr", _hoisted_73, [
              _createElementVNode("td", _hoisted_74, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.total" }),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_75, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ]),
              _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.outsideScopeResult || 0, 2)), 1)
            ]),
            _createElementVNode("tr", _hoisted_77, [
              _createElementVNode("td", _hoisted_78, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.total" }),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_79, "(" + _toDisplayString(this.electricityCalculationMethodText(!_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ]),
              _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.prettify(_ctx.results.ghgCalculatedResult?.outsideScopeResultOtherDeclaration || 0, 2)), 1)
            ])
          ])
        ], 8, _hoisted_53))
      : _createCommentVNode("", true)
  ], 64))
}